module.exports = __webpack_public_path__ + "static/media/ebay_output.254082ad.csv";